
import moment from "moment";
import { mapMutations } from "vuex";
import {
  setPush,
  deletePush,
  postCollection,
  deleteCollection,
} from "@/apis/collect";

export default {
  name: "pcard-collect-card",
  props: {
    article: {
      type: Object,
    },
  },
  computed: {
    is_login() {
      return this.$store.state.login.login_status;
    },
    member_token() {
      return this.$store.state.login.pix_member_token.member_token;
    },
    member_data() {
      return this.$store.state.login.member_data;
    },
  },
  data() {
    return {
      article_user_name: "",
      article_id: "",
      article_image: "",
      article_date: "",
      isCollect: true,
      isShowEditPost: false,
      likeCount: 0,
      isLike: false,
    };
  },
  methods: {
    ...mapMutations("share", [
      "setShareLink",
      "setShareTitle",
      "toggleShareOpen",
    ]),
    ...mapMutations("report", [
      "toggleReport",
      "updateArticleId",
      "updateArticleLink",
      "updateArticleMemberId",
    ]),
    randomImage() {
      let tmpImageArray = [
        location.origin + "/img/public/img_default_01.png",
        location.origin + "/img/public/img_default_02.png",
        location.origin + "/img/public/img_default_03.png",
      ];
      tmpImageArray.sort(() => Math.random() - 0.5);
      tmpImageArray = tmpImageArray.slice(0, 1);
      let tmpImage = tmpImageArray[0];
      return tmpImage;
    },
    openShare(link, title) {
      const vm = this;
      vm.setShareLink(link);
      vm.setShareTitle(title);
      vm.toggleShareOpen();
    },
    openReport() {
      const vm = this;
      if (vm.is_login && vm.member_token) {
        if (vm.article.author.uniqid == vm.member_data.member_uniqid) {
          vm.removeAllEditNone(vm.article_id);
          const tmpTag = document.querySelector(
            '.pcard__article .self_collect_list .collectarticlebox .collectarticlelist .editpostbox[data-article-id="' +
              vm.article_id +
              '"]'
          );
          if (tmpTag.classList.contains("none")) {
            tmpTag.classList.remove("none");
            tmpTag.classList.add("active");
          } else {
            tmpTag.classList.remove("active");
            tmpTag.classList.add("none");
          }
        } else {
          vm.removeAllEditNone("");
          vm.updateArticleMemberId(vm.article.author.uniqid);
          vm.updateArticleId(vm.article_id);
          vm.updateArticleLink(vm.article.link);
          vm.toggleReport();
        }
      } else {
        vm.removeAllEditNone("");
        location.href =
          "https://member.pixnet.cc/login/openid?openid=https://member.pixnet.cc/login&easy_login=1&done=" +
          location.href;
      }
    },
    goToEditArticle() {
      const vm = this;
      const tmpLink = "https://panel.pixnet.cc/#/edit-article/" + vm.article_id;
      location.href = tmpLink;
    },
    removeAllEditNone(dataArticleId) {
      const tmpTag = document.querySelectorAll(
        ".pcard__article .self_collect_list .collectarticlebox .collectarticlelist .articlecarditem"
      );
      tmpTag.forEach((element) => {
        if (dataArticleId) {
          const tmpArticleId = element
            .querySelector(".editpostbox")
            .getAttribute("data-article-id");
          if (dataArticleId !== tmpArticleId) {
            element.querySelector(".editpostbox").classList.remove("active");
            element.querySelector(".editpostbox").classList.add("none");
          }
        } else {
          element.querySelector(".editpostbox").classList.remove("active");
          element.querySelector(".editpostbox").classList.add("none");
        }
      });
    },
    formatDate() {
      const vm = this;
      let tmpDate = "";
      let tmpFinalDate = moment(vm.article.datetime)
        .utc()
        .locale("zh-tw")
        .format("YYYY-MM-DD HH:mm:ss");
      let tmpRealTime = moment(tmpFinalDate);
      let tmpNow = moment();
      let tmpDiffMinute = tmpNow.diff(tmpRealTime, "minutes");
      let tmpDiffHour = tmpNow.diff(tmpRealTime, "hours");
      let tmpDiffYear = tmpNow.diff(tmpRealTime, "years");
      if (tmpDiffMinute <= 5 && tmpDiffHour == 0) {
        tmpDate = "剛剛";
      } else if (tmpDiffMinute > 5 && tmpDiffHour < 1) {
        tmpDate = tmpDiffMinute + "分鐘前";
      } else if (tmpDiffMinute > 5 && tmpDiffHour >= 1 && tmpDiffHour < 24) {
        tmpDate = tmpDiffHour + "小時前";
      } else {
        if (tmpDiffHour >= 24 && tmpDiffYear < 1) {
          tmpDate = moment(tmpFinalDate).utc().locale("zh-tw").format("M/D");
        } else {
          tmpDate = moment(tmpFinalDate)
            .utc()
            .locale("zh-tw")
            .format("YYYY/M/D");
        }
      }
      vm.article_date = tmpDate;
    },
    formatImage() {
      const vm = this;
      let newImg = new Image();
      let tmpReImage = vm.article.image;
      newImg.src = tmpReImage;
      newImg.onerror = () => {
        newImg.src = vm.randomImage();
      };
      newImg.onload = () => {
        tmpReImage = newImg.src;
        if (tmpReImage.indexOf("/img_broken_rectangle.png") > -1) {
          vm.article_image = vm.randomImage();
        } else {
          vm.article_image = tmpReImage;
        }
      };
    },
    formatUserName() {
      const vm = this;
      vm.article_user_name = vm.article.author.user_name;
      vm.article_id = vm.article.id;
    },
    formatLike() {
      const vm = this;
      vm.likeCount = vm.article.counts.like_count;
      vm.isLike = vm.article.relation.like;
    },
    pushGreat() {
      const vm = this;
      if (vm.isLike) {
        vm.delGreat();
      } else {
        vm.setGreat();
      }
    },
    setGreat() {
      const vm = this;
      const tmpId = vm.article_id;
      const tmpUniqid = vm.article.author.uniqid;
      const tmpCommentId =
        tmpUniqid +
        "-blog-article://members/" +
        tmpUniqid +
        "/articles/" +
        tmpId +
        "-" +
        tmpId;
      setPush(tmpCommentId)
        .then((res) => {
          const tmpResData = res.data;
          if (!tmpResData.error) {
            const tmpData = tmpResData.data;
            vm.likeCount = tmpData.total_push;
            vm.isLike = true;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    delGreat() {
      const vm = this;
      const tmpId = vm.article_id;
      const tmpUniqid = vm.article.author.uniqid;
      const tmpCommentId =
        tmpUniqid +
        "-blog-article://members/" +
        tmpUniqid +
        "/articles/" +
        tmpId +
        "-" +
        tmpId;
      deletePush(tmpCommentId)
        .then((res) => {
          const tmpResData = res.data;
          if (!tmpResData.error) {
            const tmpData = tmpResData.data;
            vm.likeCount = tmpData.total_push;
            vm.isLike = false;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    setCollect() {
      const vm = this;
      const tmpObjectId = vm.article.author.user_name + "-" + vm.article.id;
      postCollection(tmpObjectId).then((res) => {
        const tmpResData = res.data;
        if (!tmpResData.error) {
          vm.isCollect = true;
        }
      });
    },
    delCollect() {
      const vm = this;
      const tmpObjectId = vm.article.author.user_name + "-" + vm.article.id;
      deleteCollection(tmpObjectId).then((res) => {
        const tmpResData = res.data;
        if (!tmpResData.error) {
          vm.isCollect = false;
          vm.$emit("refreshCollectList");
        }
      });
    },
  },
  mounted() {
    const vm = this;
    vm.formatDate();
    vm.formatImage();
    vm.formatUserName();
    vm.formatLike();
  },
};
